export default __webpack_public_path__ + "static/media/women-5.1cca2e99.jpg";